import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LuLandingPageTypeAppResource from './LuLandingPageTypeAppResource';

export const HOME = 13010;
export const BUY = 13020;
export const SELL = 13030;
export const FINANCE = 13040;
export const TRADE = 13050;
export const LEARN = 13060;

class LuLandingPageSectionTypeAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'lu-landing-page-section-type';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'lus/landings/pages/sections/types';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'id',
      'slug',
      'title',
      'description',
      'landingPageTypes',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      landingPageTypes:             LuLandingPageTypeAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return [
    ];
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      id: {
        type: 'string',
        presence:                 true,
      },
      slug: {
        type: 'string',
        presence:                 true,
        length: {
          maximum: 255,
        },
      },
      title: {
        type: 'string',
        presence:                 true,
        length: {
          maximum: 255,
        },
      },
      description: {
        type: 'string',
        length: {
          maximum: 255,
        },
      },
    };
  }

}

export default LuLandingPageSectionTypeAppResource;
